import React from "react";

import QRCode from "react-qr-code";

function QRGenerateButton({ QRType, QRValue, showQR, setShowQR, setInput }) {
  const downloadQR = () => {
    const svg = document.getElementById("qrcode");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = function () {
      canvas.width = img.width + (3.8 * img.width) / 100;
      canvas.height = img.height + (3.8 * img.height) / 100;
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(
        img,
        (3.8 * img.width) / 100 / 2,
        (3.8 * img.height) / 100 / 2
      );
      const pngFile = canvas.toDataURL("image/png");

      const downloadLink = document.createElement("a");
      downloadLink.download = "qrcode";
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };

    img.src = "data:image/svg+xml;base64," + window.btoa(svgData);
  };
  return (
    <div id="qrwrap">
      {showQR ? (
        <>
          <div className="qr-msg">
            <p>
              Your QR code{" "}
              {QRType === "url" ? (
                <>
                  for <mark>{QRValue}</mark>
                </>
              ) : null}{" "}
              is ready for action!
            </p>
            <QRCode id="qrcodelow" value={QRValue} size={256} />
          </div>
          <button type="button" onClick={() => downloadQR()}>
            Download
          </button>
          <div hidden className="hidden">
            <QRCode id="qrcode" value={QRValue} size={1000} />
          </div>
          <button
            type="button"
            className="outline secondary"
            onClick={() => {
              setShowQR(false);
              setInput("");
              document.getElementById("qrsection").scrollIntoView({
                behavior: "smooth",
              });
            }}
          >
            Generate New?
          </button>
          <p>Liked our tool? Please do spread the word about it. Thank you.</p>
        </>
      ) : null}
    </div>
  );
}

export default QRGenerateButton;
